module.exports = __webpack_public_path__ + "static/img/about_active1.809997f0.png";